import {
  FETCH_OPPORTUNITIES,
  FETCH_OPPORTUNITY,
  CURRENT_OPPORTUNITY_RESET,
  OPPORTUNITIES_FILTER_SET
} from '../../constants/Constants';

export const fetchOpportunities = () => ({ type: FETCH_OPPORTUNITIES.REQUESTED });
export const fetchOpportunity = postId => ({ type: FETCH_OPPORTUNITY.REQUESTED, payload: { postId } });
export const resetCurrentOpportunity = () => ({ type: CURRENT_OPPORTUNITY_RESET });
export const setOpportunitiesFilter = filter => ({ type: OPPORTUNITIES_FILTER_SET, payload: filter });



// WEBPACK FOOTER //
// ./src/actions/entities/OpportunitiesActions.js